var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_19814)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 13.414L17.6573 19.071C17.8459 19.2532 18.0985 19.354 18.3607 19.3517C18.6229 19.3494 18.8737 19.2443 19.0591 19.0588C19.2445 18.8734 19.3497 18.6226 19.352 18.3604C19.3543 18.0982 19.2535 17.8456 19.0713 17.657L13.4143 12L19.0713 6.34303C19.2535 6.15443 19.3543 5.90182 19.352 5.63963C19.3497 5.37743 19.2445 5.12662 19.0591 4.94121C18.8737 4.7558 18.6229 4.65063 18.3607 4.64835C18.0985 4.64607 17.8459 4.74687 17.6573 4.92903L12.0003 10.586L6.34331 4.92903C6.15386 4.75137 5.90272 4.65439 5.64304 4.65861C5.38336 4.66283 5.1355 4.76791 4.95192 4.95162C4.76834 5.13533 4.66343 5.38326 4.6594 5.64295C4.65537 5.90263 4.75252 6.1537 4.93031 6.34303L10.5863 12L4.92931 17.657C4.8338 17.7493 4.75762 17.8596 4.70521 17.9816C4.6528 18.1036 4.62522 18.2348 4.62406 18.3676C4.62291 18.5004 4.64821 18.6321 4.69849 18.755C4.74877 18.8779 4.82302 18.9895 4.91692 19.0834C5.01081 19.1773 5.12246 19.2516 5.24536 19.3018C5.36825 19.3521 5.49993 19.3774 5.63271 19.3763C5.76549 19.3751 5.89671 19.3475 6.01872 19.2951C6.14072 19.2427 6.25106 19.1665 6.34331 19.071L12.0003 13.414Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_19814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlack);
export default __webpack_public_path__ + "static/media/x_black.9ed6116eaea245e9dcfb2f9ad7306fe2.svg";
export { ForwardRef as ReactComponent };